import * as LucideIcons from 'lucide-react';

export default function Icon({ name, size = 20, className = "" }) {
  const LucideIcon = LucideIcons[name];
  if (!LucideIcon) return null;
  return <LucideIcon size={size} className={className} />;
}
